import React, { useState } from "react";
import { Card, Grid, Typography, Button } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import { withStyles } from "@material-ui/core/styles";
import NineBoxIndicator from "@icarius-common/nineBoxIndicator";
import { useSelector } from "react-redux";
import { getSocietySelected } from "@icarius-pages/login/selectors";
import { getAppColor } from "@icarius-app/selectors";
import QR from "@icarius-common/qr";
import Likes from "@icarius-common/likes";
import ProfileImg from "@icarius-common/profileImg";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";

export const CustomButton = withStyles({
    root: {
        color: "var(--mainText) !important",
        textTransform: "none",
        backgroundColor: "var(--tertiaryBackgroundColor)",
        width: "100%",
    },
})(Button);

const UserSummary = (props) => {
    const {
        isPhotoModificable,
        employee,
        enableQueriesButton,
        enableCertificates,
        enableReceipts,
        enablePositionDescription,
        handleOpenMyCertificates,
        handleOpenMyReceipts,
        handleOpenQueries,
        handleOpenChangeMyPersonalPhotoDialog,
        handleOpenMyCredentials,
        handleDownloadPositionDescription,
    } = props;

    const color = useSelector(getAppColor);
    const societySelected = useSelector(getSocietySelected);
    const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);

    const qr =
        employee &&
        "BEGIN:VCARD\n" +
            "VERSION:3.0\n" +
            "N:" +
            employee["APELLIDO Y NOMBRES"] +
            "\n" +
            "ORG:" +
            societySelected.name +
            "\n" +
            "TITLE:" +
            employee["CARGO"] +
            "\n" +
            "TEL:" +
            employee["CELULAR"] +
            "\n" +
            "EMAIL:" +
            employee["EMAIL"] +
            "\n" +
            "END:VCARD\n";

    return (
        <Grid container item xs={12} alignItems="center" spacing={2}>
            <Grid container alignItems="center" justify="center" item sm={12} md={2}>
                <div className={"photo-container"}>
                    <ProfileImg
                        image={employee["FOTOGRAFIA"]}
                        size={100}
                        editable={isPhotoModificable}
                        handleChange={handleOpenChangeMyPersonalPhotoDialog}
                    />
                </div>
            </Grid>
            <Grid container direction="column" item sm={12} md={8}>
                <Typography
                    style={{
                        fontWeight: 200,
                        fontSize: "20px",
                        lineHeight: "28px",
                    }}
                    className={"whiteText"}
                    variant="subtitle1"
                >
                    {employee["APELLIDO Y NOMBRES"]}
                </Typography>
                {employee?.["MANAGER"] && employee?.["MANAGER"] !== "-" && (
                    <Typography
                        style={{
                            color: color,
                            fontWeight: 400,
                            fontSize: "20px",
                            lineHeight: "28px",
                        }}
                    >
                        {getLocalizedString("managerColon") + employee["MANAGER"]}
                    </Typography>
                )}
                {Boolean(employee["nine_box"]) && (
                    <div style={{ paddingTop: 10 }}>
                        <NineBoxIndicator data={employee["nine_box"]} />
                    </div>
                )}
                <div style={{ paddingTop: 10 }}>
                    <Likes value={employee["OPINION"]} />
                </div>
            </Grid>
            <Grid container item sm={12} md={2} justify="center" alignItems="center">
                <QR value={qr} hideLabel />
            </Grid>
            <div style={{ width: "100%", display: "flex", gap: 10, flexWrap: "wrap" }}>
                <Card style={{ width: "100%", borderRadius: 10, background: color, color: "white" }}>
                    <Grid container item xs={12} direction="row" style={{ padding: "10px 20px" }}>
                        <Grid
                            onClick={() => setIsPrivacyOpen((prev) => !prev)}
                            container
                            item
                            xs={12}
                            style={{
                                cursor: "pointer",
                                alignItems: "center",
                                justifyContent: "space-between",
                            }}
                        >
                            <Typography style={{ fontWeight: "bold" }}>
                                {getLocalizedString("privacyPolicy")}
                            </Typography>
                            {isPrivacyOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </Grid>
                    </Grid>
                </Card>
                {isPrivacyOpen && (
                    <Card
                        style={{
                            width: "100%",
                            borderRadius: 10,
                            padding: 20,
                            border: "1px solid var(--borderColor)",
                            backgroundColor: "var(--tertiaryBackgroundColor)",
                        }}
                    >
                        <Typography component="div" className="whiteText">
                            "<b>ICARIUS</b>
                            {getLocalizedString("privacyPolicyContent1")}
                            <br />
                            <br />
                            {getLocalizedString("privacyPolicyContent2")}
                            <br />
                            <br />
                            {getLocalizedString("privacyPolicyContent3")}
                            <b>ICARIUS</b>
                            {getLocalizedString("privacyPolicyContent4")}
                            <h3>{getLocalizedString("privacyPolicyContent5")}</h3>
                            <ul>
                                <li>
                                    {getLocalizedString("privacyPolicyContent6")}
                                    <b>ICARIUS</b>
                                    {getLocalizedString("privacyPolicyContent7")}
                                </li>
                                <li>{getLocalizedString("privacyPolicyContent8")}</li>
                                <li>{getLocalizedString("privacyPolicyContent9")}</li>
                                <li>{getLocalizedString("privacyPolicyContent10")}</li>
                            </ul>
                            {getLocalizedString("privacyPolicyContent11")}
                            <b>ICARIUS</b>
                            {getLocalizedString("privacyPolicyContent12")}
                            <br />
                            <br />
                            {getLocalizedString("privacyPolicyContent13")}
                            <br />
                            <br />
                            {getLocalizedString("privacyPolicyContent14")}
                            <br />
                            <br />
                            {getLocalizedString("privacyPolicyContent15")}
                            <br />
                            <br />
                            {getLocalizedString("privacyPolicyContent16")}
                            <b>ICARIUS</b>
                            {getLocalizedString("privacyPolicyContent17")}
                            <h3>{getLocalizedString("privacyPolicyContent18")}</h3>
                            {getLocalizedString("privacyPolicyContent19")}
                            <b>ICARIUS</b>
                            {getLocalizedString("privacyPolicyContent20")}
                            <b>ICARIUS</b>
                            {getLocalizedString("privacyPolicyContent21")}
                            <h3>{getLocalizedString("privacyPolicyContent22")}</h3>
                            <b>ICARIUS</b>
                            {getLocalizedString("privacyPolicyContent23")}
                        </Typography>
                    </Card>
                )}
                {[
                    {
                        label: getLocalizedString("myCredential"),
                        onClick: handleOpenMyCredentials,
                        enabled: true,
                    },
                    {
                        label: getLocalizedString("certificates"),
                        onClick: handleOpenMyCertificates,
                        enabled: enableCertificates,
                    },
                    {
                        label: getLocalizedString("receipts"),
                        onClick: handleOpenMyReceipts,
                        enabled: enableReceipts,
                    },
                    {
                        label: getLocalizedString("queries"),
                        onClick: handleOpenQueries,
                        enabled: enableQueriesButton,
                    },
                    {
                        label: getLocalizedString("myPositionDescription"),
                        onClick: handleDownloadPositionDescription,
                        enabled: enablePositionDescription,
                    },
                ].map((item, index) => {
                    if (!item.enabled) return null;
                    return (
                        <div key={index} style={{ flex: 1, minWidth: 220 }}>
                            <CustomButton onClick={item.onClick} variant={"contained"}>
                                {item.label}
                            </CustomButton>
                        </div>
                    );
                })}
            </div>
        </Grid>
    );
};

export default UserSummary;
